<template>
  <div style="padding: 20px;">
    <div v-text-lbl="'meetingAgenda'" style="text-align: center;font-size: 24px;height: 60px;line-height: 60px;">会议议题</div>
    <div class="home">
      <div style="margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;">
        <div>
          <el-checkbox v-model="xxtxChecked" v-text-lbl="'messageReminder'" :disable="!canEdit">消息提醒</el-checkbox>
        </div>
        <div>
          <el-button-group>

            <el-button v-if="canEdit" v-text-lbl="'selectMeeting'" icon="el-icon-document" @click="clickSelectFn">选择议题</el-button>
            <el-button v-if="canEdit" v-pageBtn-lbl="'del'" icon="el-icon-close" @click="deleteAllFn">删 除</el-button>
            <el-button v-pageBtn-lbl="'export'" icon="el-icon-top" @click="exportWformFn">导 出</el-button>
          </el-button-group>
        </div>
      </div>
      <el-table v-if="isTableShow" :data="tableData" border row-key="date" class="draggable-table" style="width: 100%" max-height="600" @selection-change="handleSelectionChange">
        <el-table-column
          align="center"
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          type="index"
          :label="$tx('hygl.hyyt.index','序号')"
          width="50"
          align="center"
        >
          <template slot-scope="scope">
            <div>{{ scope.$index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="subject" :label="$tx('hygl.hyyt.meetingAgenda','会议议题')"></el-table-column>
        <el-table-column prop="mainDept" :label="$tx('hygl.hyyt.hostDepartment','主办部门')" width="100" align="center"></el-table-column>
        <el-table-column prop="reportPersonName" :label="$tx('hygl.hyyt.declarant','陈述人')" width="90" align="center"></el-table-column>
        <el-table-column prop="reportPersonName" :label="$tx('hygl.hyyt.startTime','开始时间')" width="230" align="center">
          <template slot-scope="scope">
            <div>
              <el-date-picker
                v-if="canEdit"
                v-model="scope.row.startTime"
                type="datetime"
                :placeholder="$tx('hygl.hyyt.selectStartTime','选择开始时间')"
              >
              </el-date-picker>
              <div v-else>
                {{ scope.row.startTime }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="reportTime" :label="$tx('hygl.hyyt.csTime','陈述时间/分钟')" width="110" align="center"></el-table-column>
        <el-table-column prop="talkTime" :label="$tx('hygl.hyyt.talkTime','讨论时间/分钟')" width="110" align="center"></el-table-column>
        <el-table-column prop="attendDept" :label="$tx('hygl.hyyt.attendDept','列席部门')" width="130" align="center"></el-table-column>
        <el-table-column prop="status" :label="$tx('hygl.hyyt.status','状态')" width="80" align="center"></el-table-column>
        <el-table-column prop="" :label="$tx('hygl.hyyt.attach','附件')" width="70" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.passenger.attachments.length }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="canEdit" prop="orderNo" :label="$tx('hygl.hyyt.order','排序')" width="80" align="center">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: center;" class="handle"><i style="font-size: 18px;" class="el-icon-rank"></i><span v-text-lbl="'move'">移动</span></div>
          </template>
        </el-table-column>
        <el-table-column v-if="canEdit" prop="caozuo" :label="$tx('hygl.hyyt.operate','操作')" width="100" align="center">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-evenly;color: #1a82e3;">
              <span v-pageBtn-lbl="'edit'" @click="editFn(scope.row)">编 辑</span>
              <span v-pageBtn-lbl="'del'" @click="delFn(scope.row)">删 除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Basicform
        :title="$tx('hygl.hyyt.ytkTitle','议题库')"
        :win-width="moduleInfo.winWidth"
        :win-height="moduleInfo.winHeight"
        :append-to-body="true"
        :toolbar-btns="busiformBtns"
        :on-basic-form-submited="onBasicFormSubmited"
      >
        <template #default="slotProps">
          <busi-form ref="ytk" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
        </template>
      </Basicform>

    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
    components: {

    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }

    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'hyyt',
            dialogVisible: false,
            tableData: [],
            row: {},
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html',
                'winWidth': 1200,
                'delUrl': '/hygl/ytRecord/delete',
                'addNewUrl': '/hygl/ytRecord/addNew',
                'insertUrl': '/hygl/ytRecord/insert',
                'moduleCode': 'budgetKpi',
                'winHeight': 600,
                'updateUrl': '/hygl/hyapYtInfo/update',
                'listDataUrl': '/hygl/hyapYtInfo/listdata',
                'getByIdUrl': '/hygl/hyapYtInfo/getById'
            },
            busiformBtns: [],
            isChange: false,
            isTableShow: true,
            xxtxChecked: false,
            selectList: []

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.openFn()
    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {
        exportWformFn() {
            this.$http({
                method: 'post',
                url: 'hygl/vwHyglMeetDirectoryYtRecord/dynamicExportData',
                params: {
                    fileName: '会议议题'

                },
                data: {
                    pager: {
                        pageSize: 9999,
                        pageNum: 1,
                        urlsearch: 'hyapId:48b1374517594a2294c99faa5d394d19',
                        orderBy: 'orderNo asc'
                    },
                    headerAlias: {
                        '会议议题': 'subject',
                        '主办部门': 'mainDept'
                    }
                }
            }).then(res => {
                console.log('res', res)
                const blobUrl = URL.createObjectURL(res)
                const link = document.createElement('a')
                link.href = blobUrl
                link.download = 'desired_filename.ext' // 替换为实际文件名和扩展名
                document.body.appendChild(link) // 需要插入文档以触发 click 事件
                link.click()
                document.body.removeChild(link) // 下载完成后移除元素
            })
        },
        deleteAllFn() {
            if (this.selectList.length > 0) {
                const ids = []
                this.selectList.forEach(item => {
                    ids.push(item.id)
                })
                this.$http({
                    method: 'delete',
                    url: '/hygl/hyapYtInfo/delete',
                    params: {
                        ids: ids.join(',')
                    }
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.$message.warning(this.$tx('hygl.message.selectData', '请先选择数据！'))
            }
        },
        handleSelectionChange(list) {
            this.selectList = list
        },
        saveChange() {
            if (this.isChange) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/modifyOrderNo',
                    data: this.tableData
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.dialogVisible = false
            }
        },
        clickSelectFn() {
            console.log('11')
            const ids = []
            this.tableData.forEach(item => {
                if (item.meetDirectoryYtRecordId) {
                    ids.push(item.meetDirectoryYtRecordId)
                }
            })
            var el = {
                attrs: {
                    'listviewurl': `vw.hyglMeetDirectoryYtRecord.list?urlsearch=id!:${ids.join(',')};status:0`,
                    'dialog-title': this.$tx('hygl.hyyt.selectMeeting', '选择议题'),
                    'exclude-fields': '',
                    'retain-btns': 'addObject,editObject',
                    'multiple': true
                }
            }
            const vnode = {
                context: this,
                'data': { model: { expression: '' }}
            }
            this.$bus.emit('openListpageDialog', el, null, vnode)
        },
        // 通用列表选择对话框-选择数据后回调
        onSelectListpageRowCompleted(selectedRows, attr) {
            console.log(attr.listviewurl, 'onSelectListpageRowCompleted')
            const ids = []
            selectedRows.forEach(item => {
                ids.push(item.id)
            })
            if (ids.length > 0) {
                this.$http({
                    method: 'post',
                    url: '/hygl/hyapYtInfo/relevanceYtRecord',
                    params: {
                        hyapId: this.vo.id
                    },
                    data: selectedRows
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getListData(this.vo)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        /**
        * 基本表单提交完成，vo为已保存成功的calendar对象，窗口即将关闭，不需要返回值
        */
        onBasicFormSubmited: function($scope, vo) {
            console.log('calendar form submited', this.moduleInfo.isShengcheng)
            if (this.moduleInfo.isShengcheng) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/relevance',
                    params: {
                        meetDirectoryId: this.row.id,
                        ytRecordIds: vo.id

                    }
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getListData(this.row)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        addFormFn() {
            this.moduleInfo.isShengcheng = true
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1, (res) => {
                    this.moduleInfo.isShengcheng = false
                })
            })
        },
        editFn(row) {
            console.log('row', row)

            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, { id: row.id }, 1, (res) => {
                    this.getListData(this.vo)
                })
            })
        },
        delFn(row) {
            this.$confirm(this.$tx('hygl.message.delFile', '此操作将永久删除该文件, 是否继续？'), this.$tx('hygl.common.tip', '提示'), {
                confirmButtonText: this.$tx('hygl.common.confirm2', '确 定'),
                cancelButtonText: this.$tx('hygl.common.cancel', '取 消'),
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'delete',
                    url: '/hygl/hyapYtInfo/delete',
                    params: {
                        ids: row.id
                    }
                }).then(res => {
                    if (res.code === 'success') {
                        console.log(res)
                        this.$message.success(res.message)
                        this.getListData(this.vo)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        async openFn() {
            this.isChange = false
            this.tableData = []
            await this.getListData(this.vo)
            this.$nextTick(() => {
                this.register()
            })
        },
        register() {
            const _this = this
            const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
            new Sortable(tbody, {
                handle: '.handle', // handle's class
                animation: 150,
                // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                onEnd: ({ newIndex, oldIndex }) => {
                    this.isTableShow = false
                    console.log('newIndex', newIndex)
                    console.log('oldIndex', oldIndex)
                    const targetRow = this.tableData[oldIndex]
                    this.tableData.splice(oldIndex, 1)
                    this.tableData.splice(newIndex, 0, targetRow)
                    console.table(this.tableData)
                    this.$nextTick(() => {
                        this.$forceUpdate()
                        this.isTableShow = true
                        this.$nextTick(() => {
                            _this.register()
                        })
                    })
                    this.isChange = true
                }
            })
        },
        getListData(vo) {
            this.$http({
                method: 'post',
                url: '/hygl/hyapYtInfo/listdata',
                params: {
                    pageSize: 9999,
                    pageNum: 1,
                    urlsearch: `hyapId:${vo.id}`,
                    orderBy: 'orderNo asc'
                }
            }).then(res => {
                if (res.code === 'success') {
                    console.log('res', res)
                    this.tableData = res.body.pageInfo.list
                }
            })
        }

    }
}
</script>

<style scoped lang="scss">
  .handle {
    cursor: move;
    display: flex;
    align-content: center;
  }
</style>
